export const LEGAL_DOCUMENT_LABELS = {
  TERMS_OF_SERVICE: 'Terms of Service',
  TERMS: 'Terms',
  PRIVACY_POLICY: 'Privacy Policy',
  RESIDENTS_TERMS: 'Residents Terms',
  RESIDENTS_PRIVACY_POLICY: 'Residents Privacy Policy',
  RESIDENTS_AUTO_PAYMENT: 'Residents Auto Payment',
  RISK_FACTORS: 'Risk Factors',
  ELECTRONIC_CERTIFICATIONS: 'Electronic W-9 Certifications',

  TESTING_THE_WATERS: 'Testing the Waters',
  DIVIDEND_INFORMATION: 'Dividend Information',

  FORM_1_A: 'Form 1-A',
  LANDA_APP_FINANCIALS_INFORMATION: 'Landa App Financials Information',
  FINANCIALS_INFORMATION: 'Financials Information',
  LANDA_APP_2_FINANCIALS_INFORMATION: 'Landa App 2 Financials Information',
  LANDA_APP_3_FINANCIALS_INFORMATION: 'Landa App 3 Financials Information',
  LANDA_APP_OPERATING_AGREEMENT: 'Landa App Operating Agreement',
  LANDA_APP_2_OPERATING_AGREEMENT: 'Landa App 2 Operating Agreement',
  LANDA_APP_3_OPERATING_AGREEMENT: 'Landa App 3 Operating Agreement',
  BROKER_DEALER_SECONDARY_AGREEMENT: 'Secondary Agreement',
  SECONDARY_LISTING_AGREEMENT: 'Secondary Listing Agreement',
  SECURITIES_TRANSFER_AGREEMENT: 'Securities Transfer Agreement',
  FREE_SHARE_PROGRAM_TERMS: 'Free Share Program Terms',
  REFERRAL_PROGRAM_TERMS: 'Referral Program Terms & Conditions',

  BROKER_DEALER_DISCLOSURE: 'Broker Dealer Disclosure',
  BROKER_DEALER_SUBSCRIBER_AGREEMENT: 'Broker Dealer Subscriber Agreement',
  BROKER_DEALER_PRIVACY_POLICY: 'Broker Dealer Privacy Policy',
  BROKER_DEALER_REGULATION_BI: 'Broker Dealer Regulation Best Interest',
  BROKERAGE_TERMS_OF_USE: 'Brokerage Terms Of Use',
  BROKERAGE_CUSTOMER_ACCOUNT_AGREEMENT: 'Brokerage Customer Account Agreement',
  BROKERAGE_ALTERNATIVE_INVESTMENTS_AGREEMENT:
    'Brokerage Alternative Investments Agreement',
  BROKERAGE_DISCLOSURES_AND_DISCLAIMERS:
    'Brokerage Disclosures and Disclaimers',
};

export const AGREEMENT_DOCUMENTS = [
  LEGAL_DOCUMENT_LABELS.ELECTRONIC_CERTIFICATIONS,
];

export const PROPERTY_DOCUMENTS = {
  SUBSCRIPTION_AGREEMENT: 'Subscription Agreement',
  OPERATING_AGREEMENT: 'Operating Agreement',
  MANAGEMENT_SERVICES_AGREEMENT: 'Management Services Agreement',
  SERIES_DESIGNATION: 'Series Designation',
  OFFERING_CIRCULAR: 'Offering Circular',
};

export const CREATING_ORDER_DOCUMENTS = [
  LEGAL_DOCUMENT_LABELS.LANDA_APP_OPERATING_AGREEMENT,
  LEGAL_DOCUMENT_LABELS.LANDA_APP_2_OPERATING_AGREEMENT,
  LEGAL_DOCUMENT_LABELS.LANDA_APP_3_OPERATING_AGREEMENT,
];
